// BUILD-042 — Unified employee workspace. Shared page-level heading for a workspace
// destination: a bold title + a muted one-line description, matching the approved reference's
// "Employee overview" / "Personal & Contacts" style (large bold black title, gray subtitle
// sentence below it) — the prior pass used a small gray UPPERCASE caption with no page title at
// all, which read flatter than the reference. One component so every destination (My HR and HR
// Administration's employee view) gets the same typography automatically.
import type { ReactNode } from 'react';

export function SectionHeading({ title, subtitle, badge }: { title: string; subtitle?: string; badge?: ReactNode }) {
  return (
    <div className="flex items-start justify-between gap-3 mb-5">
      <div>
        <h1 className="text-xl font-bold text-gray-900 leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {badge}
    </div>
  );
}

/** Shared card-title row — bold, dark, normal case (replacing the small gray UPPERCASE caption
 *  convention), matching the reference's "Current employment" / "Personal contact information"
 *  card titles. */
export function CardTitle({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
      <h2 className="text-sm font-semibold text-gray-900">{children}</h2>
      {action}
    </div>
  );
}

/** Small blue "Planned" badge matching the reference's top-right readiness label on an
 *  unbuilt destination (e.g. Benefits). */
export function PlannedBadge() {
  return <span className="text-xs font-medium text-[#4AABDE] flex-shrink-0">Planned</span>;
}
